module.exports = __webpack_public_path__ + "media/images/logos/logo-glin-white-0903cc94bf1814eaf306343c570dd5b8.svg";